// Curated answers for the "Ask a question" search. These show as an answer card
// above the general results when a question matches them well.
//
// - question: how a member might phrase it (searched, weighted highly)
// - keywords: extra words that should find this answer (searched, weighted highly)
// - answer:   one or two sentences — keep facts here in step with the linked page
// - links:    where to go next (site paths or /assets PDFs)
export const SEARCH_FAQ = [
  {
    question: "Who are the current winners?",
    keywords: "winners results awards fish of the month trophies cups leaderboard standings champion prize who won",
    answer: "The Current Winners page shows this year's Fish of the Month awards and trophy standings, updated as catches are recorded.",
    links: [
      { label: "Current Winners & Awards", url: "/awards" },
      { label: "Ray & Bass Hunt leaderboard", url: "/ray-bass-hunt" },
    ],
  },
  {
    question: "Ray & Bass Hunt leaderboard",
    keywords: "ray bass hunt leaderboard standings october",
    answer: "The Ray & Bass Hunt page has the rules and the live leaderboard.",
    links: [{ label: "Ray & Bass Hunt", url: "/ray-bass-hunt" }],
  },
  {
    question: "What are the weigh-in procedures?",
    keywords: "weigh in weighing measuring measure procedure photo photograph scales tare sling catch release how to weigh",
    answer: "Zero (tare) the scales with the bag or weigh sling first, then weigh the fish and take a clear photo showing the recorded weight. The full step-by-step guide covers measuring and photos too.",
    links: [
      { label: "Weighing & Measuring Procedures", url: "/weigh-measure" },
      { label: "Weighing Scales Policy", url: "/scales-policy" },
    ],
  },
  {
    question: "How should I handle and unhook a fish?",
    keywords: "fish handling unhooking unhook release releasing wet hands mat sling disgorger circle hooks barbless weever stingray ray skate shark descender barotrauma",
    answer: "Use wet hands, a wet mat and a sling, keep the fish out of the water as briefly as possible, and hold it in the water until it swims off. The handling guide also covers weevers, stingrays and rays.",
    links: [{ label: "Weighing & Measuring Procedures", url: "/weigh-measure" }],
  },
  {
    question: "What is the weighing scales policy?",
    keywords: "scales policy certified calibrated scales check",
    answer: "The Weighing Scales Policy sets out which scales can be used for club weigh-ins and records.",
    links: [
      { label: "Weighing Scales Policy", url: "/scales-policy" },
      { label: "Scales Policy (PDF)", url: "/assets/rsaa_weighing_scales_policy.pdf" },
    ],
  },
  {
    question: "What is the Cornwall Recreational Sea Angling Strategy?",
    keywords: "cornwall sea angling strategy rsas ifca draft proposal voice netting ghost nets bait gathering bycatch",
    answer: "A community-led draft strategy from Cornish Recreational Sea Angling Voice, proposed to Cornwall IFCA. It covers angler involvement, catch monitoring, commercial netting, ghost nets, bait gathering and more.",
    links: [
      { label: "Cornwall Sea Angling Strategy", url: "/sea-angling-strategy" },
      { label: "Strategy (PDF)", url: "/assets/Cornwall-Recreational-Sea-Angling-Strategy-Draft.pdf" },
    ],
  },
  {
    question: "What are the club rules?",
    keywords: "rules club rules regulations constitution competition rules",
    answer: "The Club Rules and Constitution are available as PDFs. Each competition also has its own rules sheet, linked from its entry on the Fixtures page.",
    links: [
      { label: "Club Rules (PDF)", url: "/assets/rsaa_club_rules.pdf" },
      { label: "RSAA Constitution (PDF)", url: "/assets/rsaa_constitution.pdf" },
      { label: "Fixtures & competition rules", url: "/fixtures" },
      { label: "All club documents", url: "/documents" },
    ],
  },
  {
    question: "What are the competition rules?",
    keywords: "competition rules comp rules match rules month long rover colin rule conger beach float spin easter",
    answer: "Every fixture on the Fixtures page links to its own rules sheet. Month-long competitions share one set of rules each for shore and boat.",
    links: [
      { label: "Fixtures & competition rules", url: "/fixtures" },
      { label: "Month Long Shore Competitions (PDF)", url: "/assets/month_long_shore_comps.pdf" },
      { label: "Month Long Boat Competitions (PDF)", url: "/assets/month_long_boat_comps.pdf" },
    ],
  },
  {
    question: "When are the fixtures?",
    keywords: "fixtures calendar dates competitions events boat trips schedule programme",
    answer: "The Fixtures page lists every shore and boat competition and club boat trip for the year, with times, weigh-in details and rules.",
    links: [
      { label: "Fixtures", url: "/fixtures" },
      { label: "Club Fixtures (PDF)", url: "/assets/club_fixtures_2026.pdf" },
    ],
  },
  {
    question: "How do I join the club and how much is membership?",
    keywords: "join membership member sign up cost price fee how much subscription adult junior",
    answer: "Adult membership is £15 and junior membership is £1. Complete the online form and pay by card or bank via SumUp, or come along to a club meeting and pay in person.",
    links: [{ label: "Membership", url: "/membership" }],
  },
  {
    question: "When is the next club meeting?",
    keywords: "meeting meetings agenda minutes monthly club meeting AGM",
    answer: "The Upcoming Meeting page has the date, agenda and previous minutes.",
    links: [{ label: "Meeting Agenda & Minutes", url: "/upcoming-meeting" }],
  },
  {
    question: "Who are the club officers?",
    keywords: "officers committee chairman president secretary treasurer recorder competition secretary youth welfare webmaster who runs",
    answer: "The Officers page lists the club committee and officers.",
    links: [{ label: "Club Officers", url: "/officers" }],
  },
  {
    question: "How do I contact the club?",
    keywords: "contact email phone whatsapp message get in touch",
    answer: "Use the Contact page to send a message or find the club's WhatsApp details.",
    links: [{ label: "Contact", url: "/contact" }],
  },
  {
    question: "Where are the club records?",
    keywords: "records club record official record biggest heaviest best fish catch release c&r junior records",
    answer: "There are separate tables for official club records, catch & release records, and junior records, all updated as new catches are verified.",
    links: [
      { label: "Official Club Records", url: "/rsaa-records" },
      { label: "Catch & Release Records", url: "/records" },
      { label: "Junior Records", url: "/junior-records" },
      { label: "Junior C&R Records", url: "/junior-catch-release" },
    ],
  },
  {
    question: "What is the species hunt?",
    keywords: "species hunt specie hunt how many species",
    answer: "The Species Hunt is a challenge to track and log the different sea fish species you catch around Cornwall.",
    links: [
      { label: "Species Hunt", url: "/species-hunt" },
      { label: "Species Hunt Rules (PDF)", url: "/assets/rsaa_species_hunt_rules.pdf" },
    ],
  },
  {
    question: "What are the CFSA specimen weights?",
    keywords: "cfsa specimen weights percentage calculator qualifying one day specimen",
    answer: "The Specimen Calculator works out a fish's percentage of the CFSA specimen weight for shore or boat.",
    links: [
      { label: "Specimen Calculator", url: "/cfsa-specimen" },
      { label: "CFSA Shore Specimen Weights (PDF)", url: "/assets/cfsa_shore_specimen_weights.pdf" },
      { label: "CFSA Boat Specimen Weights (PDF)", url: "/assets/cfsa_boat_specimen_weighs.pdf" },
    ],
  },
  {
    question: "What are the tide times?",
    keywords: "tide tides high tide low tide times",
    answer: "Just Tides has tide times and tide charts for Cornwall; Sea Conditions covers sea temperature and weather.",
    links: [
      { label: "Just Tides", url: "/just-tides" },
      { label: "Sea Conditions", url: "/fishing-conditions" },
    ],
  },
  {
    question: "Where can I fish in Cornwall?",
    keywords: "where to fish marks venues spots beaches places north coast south coast",
    answer: "Places to Fish in Cornwall lists shore marks — beaches, rocks, harbours, piers and estuaries — with Google Maps links.",
    links: [{ label: "Places to Fish in Cornwall", url: "/fishing-marks" }],
  },
  {
    question: "Where are the tackle and bait shops?",
    keywords: "tackle shop bait shop buy bait local services",
    answer: "See Tackle & Bait Shops for local shops, and Local Services for other services recommended by the club.",
    links: [
      { label: "Tackle & Bait Shops", url: "/tackle-shops" },
      { label: "Local Services", url: "/services" },
    ],
  },
  {
    question: "Angler safety and risk assessments",
    keywords: "safety safe what3words emergency risk assessment boat shore lifejacket",
    answer: "Angler Safety explains what3words and emergency guidance. The shore and boat risk assessments are available as PDFs.",
    links: [
      { label: "Angler Safety & what3words", url: "/angler-safety" },
      { label: "Shore Risk Assessment (PDF)", url: "/assets/Shore_Fishing_Risk_Assessment.pdf" },
      { label: "Boat Risk Assessments (PDF)", url: "/assets/Boat_Risk_Assessments.pdf" },
    ],
  },
  {
    question: "Juniors and safeguarding",
    keywords: "junior juniors youth children kids safeguarding parent guardian consent welfare",
    answer: "Juniors are welcome. A parent or guardian must co-sign the membership application. See the Safeguarding Policy and parental consent form.",
    links: [
      { label: "Safeguarding Policy (PDF)", url: "/assets/Safeguarding_Policy.pdf" },
      { label: "Parental Consent Form (PDF)", url: "/assets/rsaa_parential_consent_form.pdf" },
      { label: "Membership", url: "/membership" },
    ],
  },
  {
    question: "How do I pay the club?",
    keywords: "pay payment payments entry fee sumup card membership subscription senior junior",
    answer: "Club Payments lets you pay for membership, boat trips, competition entries and other club events by card or bank transfer.",
    links: [{ label: "Club Payments", url: "/payments" }],
  },
  {
    question: "Club merchandise",
    keywords: "merchandise merch clothing shirt hoodie hat buy kit",
    answer: "See Club Merchandise for what's available.",
    links: [{ label: "Club Merchandise", url: "/merchandise" }],
  },
  {
    question: "Live sea webcams",
    keywords: "webcam webcams camera live sea views",
    answer: "Sea Views has live webcams around the Cornish coast.",
    links: [{ label: "Sea Views — Live Webcams", url: "/sea-views" }],
  },
];
